/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaResponse model module.
 * @module model/AqaResponse
 * @version v0
 */
export default class AqaResponse {
  /**
   * Constructs a new <code>AqaResponse</code>.
   * @alias module:model/AqaResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaResponse} obj Optional instance to populate.
   * @return {module:model/AqaResponse} The populated <code>AqaResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaResponse.prototype.message = undefined;

/**
 * @member {Boolean} successful
 */
AqaResponse.prototype.successful = undefined;

